/* Omnis Animations — scroll reveal + hover effects */
(function () {
  'use strict';

  /* ── SCROLL REVEAL ──────────────────────────────────── */
  var REVEAL_CLASS = 'omnis-reveal';
  var VISIBLE_CLASS = 'omnis-visible';

  // Selectors to animate on scroll
  var TARGETS = [
    '.banner__content',
    '.rich-text__wrapper h2, .rich-text__wrapper h3, .rich-text__wrapper p, .rich-text__wrapper .button',
    '.featured-product__info h2, .featured-product__info h3, .featured-product__info .price, .featured-product__info .product-form',
    '.multicolumn-card',
    '.image-with-text__content h2, .image-with-text__content p, .image-with-text__content .button',
    '.image-with-text__media-item',
    '[data-section-type="custom-liquid"] h2, [data-section-type="custom-liquid"] p'
  ].join(', ');

  function initReveal() {
    // Also target pain point cards and our custom sections
    var allTargets = document.querySelectorAll(
      '.banner__content, .rich-text__wrapper, .multicolumn-card, ' +
      '.image-with-text__content, .image-with-text__media-item, ' +
      '.featured-product__media-wrapper, .featured-product .product-form__buttons, ' +
      '.featured-product .price__container'
    );

    // Target pain point divs inside custom liquid
    var painCards = document.querySelectorAll('[style*="background:#0D0D0D"]');

    var toReveal = Array.from(allTargets).concat(Array.from(painCards));

    toReveal.forEach(function (el, i) {
      el.classList.add(REVEAL_CLASS);
      // Stagger multicolumn cards
      if (el.classList.contains('multicolumn-card')) {
        var siblings = el.parentElement ? el.parentElement.querySelectorAll('.multicolumn-card') : [];
        var idx = Array.from(siblings).indexOf(el);
        el.style.transitionDelay = (idx * 0.12) + 's';
      }
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE_CLASS);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    toReveal.forEach(function (el) { obs.observe(el); });
  }

  /* ── HOVER EFFECTS ──────────────────────────────────── */
  function initHover() {
    // Product card image zoom already handled by CSS
    // Add lift to multicolumn cards and card-wrappers
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      card.style.transition = 'transform 0.28s cubic-bezier(0.25,0.46,0.45,0.94), box-shadow 0.28s ease';
      card.addEventListener('mouseenter', function () {
        card.style.transform = 'translateY(-6px)';
        card.style.boxShadow = '0 16px 40px rgba(0,0,0,0.4)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
        card.style.boxShadow = '';
      });
    });

    // Multicolumn cards
    document.querySelectorAll('.multicolumn-card').forEach(function (card) {
      card.style.transition = 'transform 0.28s cubic-bezier(0.25,0.46,0.45,0.94), border-color 0.2s';
      card.addEventListener('mouseenter', function () {
        card.style.transform = 'translateY(-5px)';
        card.style.borderColor = '#CC0000';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
        card.style.borderColor = '';
      });
    });
  }

  /* ── INIT ───────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initHover();
    });
  } else {
    initReveal();
    initHover();
  }
})();
